/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type MeterUsageBucket = {
  /**
   * Inclusive bucket boundary
   */
  from: Date;
  /**
   * Exclusive bucket boundary
   */
  to: Date;
  /**
   * Exact integer ordinary usage quantity as a decimal string
   */
  total: string;
};

/** @internal */
export const MeterUsageBucket$inboundSchema: z.ZodMiniType<
  MeterUsageBucket,
  unknown
> = z.object({
  from: z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
  to: z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
  total: z.string(),
});

export function meterUsageBucketFromJSON(
  jsonString: string,
): SafeParseResult<MeterUsageBucket, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MeterUsageBucket$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MeterUsageBucket' from JSON`,
  );
}
